import { fmtDate } from "utils/date";
import React, { useState, useEffect } from "react";
import {
  Button, FormGroup, Label, Input, Row, Col, Table, Form
} from "reactstrap";
import { AlumnoService } from "service/AlumnoService";

const alumnoService = new AlumnoService();

const emptyIncidencia = { asunto: "", descripcion: "" };

const PanelIncidencias = ({ data, onClose }) => {
  const [listIncidencias, setListIncidencias] = useState([]);
  const [incidencia, setIncidencia] = useState(emptyIncidencia);
  const [idIncidencia, setIdIncidencia] = useState(null);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    if (data) {
      loadIncidencias();
      resetForm();
    }
  }, [data]);

  const loadIncidencias = async () => {
    try {
      const params = {
        alumno: data.alumno_id,
        matricula: data.matricula_id,
        ciclo: data.ciclo?._id || data.ciclo
      };
      const res = await alumnoService.getIncidencias(params);
      setListIncidencias(res?.data || []);
    } catch (error) {
      console.error("Error cargando incidencias:", error);
    }
  };

  const resetForm = () => {
    setIncidencia(emptyIncidencia);
    setIdIncidencia(null);
    setShowForm(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setIncidencia(prev => ({ ...prev, [name]: value }));
  };

  const handleEdit = (item) => {
    setIncidencia({
      asunto: item.asunto || "",
      descripcion: item.descripcion || "",
    });
    setIdIncidencia(item._id);
    setShowForm(true);
  };

  const handleSave = async () => {
    try {
      const dto = {
        ...incidencia,
        alumno: data.alumno_id,
        matricula: data.matricula_id,
        ciclo: data.ciclo?._id || data.ciclo,
        documentoidentidad: data.documentoidentidad
      };
      let res;
      if (idIncidencia) {
        dto._id = idIncidencia;
        res = await alumnoService.updateIncidencia(dto);
      } else {
        res = await alumnoService.addIncidencia(dto);
      }
      if (res?.confirmation === "success") {
        resetForm();
        loadIncidencias();
      }
    } catch (error) {
      console.error("Error guardando incidencia:", error);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <span className="text-muted" style={{ fontSize: "0.85rem" }}>Alumno: {data?.nombres}</span>
        {!showForm && (
          <Button color="success" size="sm" onClick={() => setShowForm(true)}>
            <i className="tim-icons icon-simple-add mr-1" /> Nueva Incidencia
          </Button>
        )}
      </div>

      {showForm && (
        <div className="p-3 border rounded mb-3">
          <h6 className="title">{idIncidencia ? "Editar Incidencia" : "Nueva Incidencia"}</h6>
          <Form>
            <Row>
              <Col md="12">
                <FormGroup>
                  <Label>Asunto</Label>
                  <Input type="text" name="asunto" value={incidencia.asunto} onChange={handleChange} />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md="12">
                <FormGroup>
                  <Label>Descripción</Label>
                  <Input
                    type="textarea"
                    name="descripcion"
                    value={incidencia.descripcion}
                    onChange={handleChange}
                    rows="3"
                  />
                </FormGroup>
              </Col>
            </Row>
            <div className="d-flex justify-content-end" style={{ gap: "8px" }}>
              <Button color="secondary" size="sm" onClick={resetForm}>Cancelar</Button>
              <Button color="primary" size="sm" onClick={handleSave}>Guardar Incidencia</Button>
            </div>
          </Form>
        </div>
      )}

      <Table responsive size="sm">
        <thead className="text-primary">
          <tr>
            <th>Asunto</th>
            <th>Descripción</th>
            <th>Fecha</th>
            <th className="text-right">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {listIncidencias.map((item, idx) => (
            <tr key={idx}>
              <td style={{ fontWeight: "bold" }}>{item.asunto}</td>
              <td>{item.descripcion}</td>
              <td>{fmtDate(item.fechacreacion)}</td>
              <td className="text-right">
                <Button
                  color="info" size="sm" className="btn-icon btn-link"
                  title="Editar incidencia"
                  onClick={() => handleEdit(item)}
                >
                  <i className="tim-icons icon-pencil" />
                </Button>
              </td>
            </tr>
          ))}
          {listIncidencias.length === 0 && (
            <tr>
              <td colSpan="4" className="text-center text-muted">No hay incidencias registradas</td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default PanelIncidencias;
